/**
 * CSV text for downloads that carry user-entered text (notes, names). RFC 4180
 * quoting, plus formula-injection hardening: a cell a spreadsheet would read as a
 * formula (starts with = + - @, tab or CR) gets a leading apostrophe.
 */
const FORMULA_START = /^[=+\-@\t\r]/;

export function csvField(value: string): string {
  const safe = FORMULA_START.test(value) ? `'${value}` : value;
  return /[",\r\n]/.test(safe) ? `"${safe.replace(/"/g, '""')}"` : safe;
}

export function toCsv(headers: readonly string[], rows: readonly Record<string, string>[]): string {
  return [
    headers.map(csvField).join(','),
    ...rows.map((row) => headers.map((h) => csvField(row[h] ?? '')).join(',')),
  ].join('\n');
}

/**
 * Saves text as a CSV through a temporary link. A UTF-8 byte-order mark goes
 * first so Excel reads non-ASCII names correctly (toCsv itself stays BOM-free).
 * The object URL is revoked on the next tick, once the click has started the download.
 */
export function downloadCsv(text: string, filename: string): void {
  const blob = new Blob(['\uFEFF', text], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `${filename}.csv`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 0);
}
